/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from "react-i18next";

export const useUtils = () => {
  const { t } = useTranslation();
  const getLabelFromValue = (value: string, currency: string) => {
    switch (value) {
      case "number_of_sites":
        return t("readings.no_of_sites");
      case "number_of_users":
        return t("readings.no_of_users");
      case "pending_alerts":
        return t("readings.pending_alerts");
      case "total_revenue":
        return t("readings.total_revenue", { currency });
      case "total_expected_revenue":
        return t("readings.expected_revenue", { currency });
      case "expected_revenue":
        return t("readings.expected_revenue", { currency });
      case "atc_losses":
        return t("readings.atc_losses");
      case "total_amount":
        return t("readings.total_amount", { currency });
      case "current_load":
        return t("readings.current_load");
      case "total_consumption":
        return t("readings.total_consumption");
      case "avg_availability":
        return t("readings.avg_availability");
      case "power_cuts":
        return t("readings.power_cuts");
      case "overloaded_dts":
        return t("readings.overloaded_dts");
      case "reactive_power":
        return t("readings.reactive_power");
      case "downtime_losses":
        return t("readings.downtime_losses", { currency });
      case "tariff_losses":
        return t("readings.tariff_losses", { currency });
      case "revenue_per_hour":
        return t("readings.revenue_per_hour", { currency });
      case "distributed_electricity":
        return t("readings.distributed_electricity");
      case "year_of_production":
        return t("readings.year_of_production");
      case "asset_type":
        return t("readings.asset_type");
      case "asset_capacity":
        return t("readings.asset_capacity");
      case "asset_position":
        return t("readings.asset_position");
      case "power_factor":
        return t("readings.power_factor");
      case "power_factor_penalty":
        return t("readings.power_factor_penalty");
      case "voltage_unbalance":
        return t("readings.voltage_unbalance");
      case "current_unbalance":
        return t("readings.current_unbalance");
      case "harmonic_distortion_phase_a":
        return t("readings.harmonic_distortion_phase_a");
      case "harmonic_distortion_phase_b":
        return t("readings.harmonic_distortion_phase_b");
      case "harmonic_distortion_phase_c":
        return t("readings.harmonic_distortion_phase_c");
      case "voltage_phase_a":
        return t("readings.voltage_phase_a");
      case "voltage_phase_b":
        return t("readings.voltage_phase_b");
      case "voltage_phase_c":
        return t("readings.voltage_phase_c");
      case "current_phase_a":
        return t("readings.current_phase_a");
      case "current_phase_b":
        return t("readings.current_phase_b");
      case "current_phase_c":
        return t("readings.current_phase_c");
      case "neutral_current":
        return t("readings.neutral_current");
      case "apparent_power":
        return t("readings.apparent_power");
      case "frequency":
        return t("readings.frequency");
      case "energy_loss":
        return t("readings.energy_loss");
      case "cO2_emissions":
        return t("readings.co2_emissions");

      default:
        return t("readings.unknown");
    }
  };
const mapResponseToLabelValue = (data: any) => {
  return Object.entries(data).map(([key, value]) => ({
    key, 
    label: getLabelFromValue(key, data.currency),
    value,
  }));
};
  const FEEDBACK_MESSAGES = {
    NO_DATA: t("feedback_msg.no_data"),
    UPCOMING: t("feedback_msg.upcoming"),
    ERROR: t("feedback_msg.error_fetching"),
    NO_DEVICE: t("feedback_msg.no_device"),
  };
const CONDITIONS = [
  {
    key: t("map.transformer_load_rate"),
    value: "transformer_load_rate",
  },
  {
    key: t("map.transformer_status"),
    value: "transformer_status",
  },
  // {
  //   key: "Voltage",
  //   value: "voltage",
  // },
  // {
  //   key: "Frequency",
  //   value: "frequency",
  // },
  // {
  //   key: "Power Factor",
  //   value: "power_factor",
  // },
];
  const INSTATAENOUS_KPIS = [
    t("readings.current_load"),
    t("readings.overloaded_dts"),
    t("readings.reactive_power"),
    t("readings.voltage_unbalance"),
    t("readings.current_unbalance"),
    t("readings.harmonic_distortion_phase_a"),
    t("readings.harmonic_distortion_phase_b"),
    t("readings.harmonic_distortion_phase_c"),
    t("readings.current_phase_a"),
    t("readings.current_phase_b"),
    t("readings.current_phase_c"),
    t("readings.voltage_phase_a"),
    t("readings.voltage_phase_b"),
    t("readings.voltage_phase_c"),
    t("readings.apparent_power"),
    t("readings.power_factor"),
    t("readings.frequency"),
  ];
  const CONDITION_LABELS = {
    transformer_load_rate: {
      grey: "0%",
      blue: "1-30%",
      deepGreen: "31-50%",
      lightGreen: "51-80%",
      yellow: "81-100%",
      orange: "101 - 120%",
      red: ">120%",
    },
    transformer_status: {
      green: "Online",
      grey: "Offline",
    },
    voltage: {
      green: "Normal (210-230V)",
      orange: "Warning (200-209V, 231-240V)",
      red: "Critical (<200V, >240V)",
    },
    frequency: {
      green: "Normal (49.5-50.5Hz)",
      orange: "Warning (48.5-49.4Hz, 50.6-51.5Hz)",
      red: "Critical (<48.5Hz, >51.5Hz)",
    },
    power_factor: {
      green: "Good (0.9-1.0)",
      orange: "Fair (0.8-0.89)",
      red: "Poor (<0.8)",
    },
  };
  const EXPORT_PARAMETERS = [
    {
      category: t("chart.voltage_profile_label"),
      parameters: [
        {
          name: t("readings.line_neutral_voltage_a"),
          value: "line_to_neutral_voltage_phase_a",
        },
        {
          name: t("readings.line_neutral_voltage_b"),
          value: "line_to_neutral_voltage_phase_b",
        },
        {
          name: t("readings.line_neutral_voltage_c"),
          value: "line_to_neutral_voltage_phase_c",
        },
      ],
    },
    {
      category: t("readings.harmonic_distortion_label"),
      parameters: [
        {
          name: t("readings.harmonic_distortion_phase_a"),
          value: "total_harmonic_distortion_current_phase_a",
        },
        {
          name: t("readings.harmonic_distortion_phase_b"),
          value: "total_harmonic_distortion_current_phase_b",
        },
        {
          name: t("readings.harmonic_distortion_phase_c"),
          value: "total_harmonic_distortion_current_phase_c",
        },
      ],
    },
    {
      category: t("chart.current_profile_label"),
      parameters: [
        {
          name: t("readings.line_current_overall_phase_a"),
          value: "line_current_overall_phase_a",
        },
        {
          name: t("readings.line_current_overall_phase_b"),
          value: "line_current_overall_phase_b",
        },
        {
          name: t("readings.line_current_overall_phase_c"),
          value: "line_current_overall_phase_c",
        },
        {
          name: t("readings.line_current_overall_neutral"),
          value: "line_current_overall_neutral",
        },
      ],
    },
    {
      category: t("readings.power_factor"),
      parameters: [
        {
          name: t("readings.power_factor_overall"),
          value: "power_factor_overall",
        },
        {
          name: t("readings.power_factor_overall_phase_a"),
          value: "power_factor_overall_phase_a",
        },
        {
          name: t("readings.power_factor_overall_phase_b"),
          value: "power_factor_overall_phase_b",
        },
        {
          name: t("readings.power_factor_overall_phase_c"),
          value: "power_factor_overall_phase_c",
        },
      ],
    },
    {
      category: t("readings.current_unbalance"),
      parameters: [
        {
          name: t("readings.current_unbalance"),
          value: "current_unbalance_factor",
        },
      ],
    },
    {
      category: t("readings.voltage_unbalance"),
      parameters: [
        {
          name: t("readings.voltage_unbalance"),
          value: "voltage_unbalance_factor",
        },
      ],
    },
    {
      category: t("chart.transformer_load_rate"),
      parameters: [
        {
          name: t("chart.transformer_load_rate"),
          value: "transformer_load_percentage",
        },
      ],
    },
  ];


  return { getLabelFromValue, mapResponseToLabelValue, t, FEEDBACK_MESSAGES, CONDITIONS, INSTATAENOUS_KPIS, CONDITION_LABELS, EXPORT_PARAMETERS};
};
